import React from 'react';
import { bool, func, node, number, oneOf, oneOfType, string } from 'prop-types';
import { noop } from '@ajaibid/utils';
import { styRow } from './style';

const Row = (props) => {
  const { align, children, className, hover, noGutters, onClick, onKeyDown, padding, ...rest } =
    props;

  return (
    <div
      className={`${styRow({ align, hover, noGutters, padding })} ${className}`}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') onClick();
        onKeyDown();
      }}
      {...(hover ? { tabIndex: 0 } : {})}
      {...rest}
    >
      {children}
    </div>
  );
};

Row.propTypes = {
  align: oneOf([
    'top-left',
    'left',
    'bottom-left',
    'top',
    'center',
    'bottom',
    'top-right',
    'right',
    'bottom-right',
    'top-between',
    'between',
    'bottom-between',
  ]),
  children: node,
  className: string,
  hover: bool,
  noGutters: bool,
  onClick: func,
  onKeyDown: func,
  padding: oneOfType([string, number]),
};

Row.defaultProps = {
  align: 'left',
  children: null,
  className: '',
  hover: false,
  noGutters: false,
  onClick: noop,
  onKeyDown: noop,
  padding: '12px 16px',
};

export default Row;
